import { CorreoElectronico } from "./correo-electronico.model";
import { Direccion } from "./direccion.model";
import { Telefono } from "./telefono.model";

export class Contacto {
    id: number;
    correosElectronicos: CorreoElectronico[];
    telefonos: Telefono[];
    direcciones: Direccion[];
    contactoCompleto: string;
    sitioWeb: string;
    correoElectronico: string;

    /**
     * Constructor
     *
     * @param contacto
     */
    constructor(contacto) {
        {
            this.id = contacto.id || null;
            this.correosElectronicos = contacto.correosElectronicos || [];
            this.telefonos = contacto.telefonos || [];
            this.direcciones = contacto.direcciones || [];
            this.sitioWeb = contacto.sitioWeb || "";
            this.contactoCompleto = contacto.contactoCompleto || "";
            this.correoElectronico = contacto.correoElectronico || "";
        }
    }

    addCorreo(correo: CorreoElectronico) {
        this.correosElectronicos.push(correo);
    }

    setCorreo(correo: CorreoElectronico) {
        this.correosElectronicos = [];
        this.correosElectronicos.push(correo);
    }

    addTelefono(telefono: Telefono) {
        this.telefonos.push(telefono);
    }

    addDireccion(direccion: Direccion) {
        //si no exixte la direccion, se agrega, si existe se modifican los datos
        var index = this.direcciones.findIndex(
            (dir) => dir.tipo == direccion.tipo
        );
        if (index != -1) {
            this.direcciones[index] = direccion;
            return;
        }
        this.direcciones.push(direccion);
    }

    getDireccionByType(tipo: string, direcciones: any[]) {
        if (!direcciones || direcciones.length == 0) {
            direcciones = this.direcciones;
        }
        var direccion = direcciones.find((direccion) => direccion.tipo == tipo);
        return direccion || new Direccion({});
    }
}
